/** @jsxRuntime classic */
/** @jsx jsx */
import { useTranslation } from 'react-i18next';
import { css, jsx } from '@emotion/react';

import MuiDialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import { useMeetingQuery } from '../../actions/MeetingActions';
import InfoBlock from '../documents/blocks/InfoBlock';

export default function MeetingInfoDialog({ data, open, onClose }) {
  const { t } = useTranslation();
  const { meeting } = useMeetingQuery(data?.meetingId);

  if (!meeting) return null;
  return (
    <MuiDialog open={open} onClose={() => onClose()} fullWidth maxWidth="md">
      <DialogTitle>{t('Information')}</DialogTitle>
      <DialogContent>
        <div
          css={css`
            padding-bottom: 20px;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          `}
        >
          <IconButton
            css={css`
              border-radius: 0.5rem;
              position: absolute;
              top: 1rem;
              right: 1rem;
            `}
            onClick={() => onClose()}
            size="small"
          >
            <CloseOutlinedIcon />
          </IconButton>
          <InfoBlock meeting={meeting} />
        </div>
      </DialogContent>
    </MuiDialog>
  );
}
